import { order as actions } from "actions";
import { statuses } from "api";

const initialState = {
   temp: {
      status: statuses.idle,
   },
};

function orderSaga(state = initialState, { type, payload }: any) {
   switch (type) {
      case actions.temp.send:
         return {
            ...state,
            temp: {
               status: statuses.pending,
               ...payload,
            },
         };
      case actions.temp.success:
         return {
            ...state,
            temp: {
               status: statuses.resolved,
               ...payload,
            },
         };
      case actions.temp.fail:
         return {
            ...state,
            temp: {
               status: statuses.rejected,
               reset: actions.temp.reset,
               ...payload,
            },
         };
      case actions.temp.reset:
         return {
            ...state,
            temp: {
               status: statuses.idle,
               ...payload,
            },
         };
      default:
         return state;
   }
}

export default orderSaga;

export { actions };
export { orderSaga };
